"use strict";
exports.__esModule = true;
exports.Radio = void 0;
var tslib_1 = require("tslib");
var antd_1 = require("antd");
var React = tslib_1.__importStar(require("react"));
var field_1 = tslib_1.__importDefault(require("../field"));
var Radio = function (_a) {
    var name = _a.name, validate = _a.validate, fast = _a.fast, onChange = _a.onChange, restProps = tslib_1.__rest(_a, ["name", "validate", "fast", "onChange"]);
    return (React.createElement(field_1["default"], { name: name, validate: validate, fast: fast }, function (_a) {
        var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
        return (React.createElement(antd_1.Radio, tslib_1.__assign({ name: name, id: name, value: value, onChange: function (event) {
                setFieldValue(name, event.target.value);
                setFieldTouched(name, true, false);
                onChange && onChange(event);
            } }, restProps)));
    }));
};
exports.Radio = Radio;
exports["default"] = exports.Radio;
exports.Radio.Group = function (_a) {
    var name = _a.name, validate = _a.validate, fast = _a.fast, onChange = _a.onChange, restProps = tslib_1.__rest(_a, ["name", "validate", "fast", "onChange"]);
    return (React.createElement(field_1["default"], { name: name, validate: validate, fast: fast }, function (_a) {
        var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
        return (React.createElement(antd_1.Radio.Group, tslib_1.__assign({ name: name, value: value, onChange: function (event) {
                setFieldValue(name, event.target.value);
                setFieldTouched(name, true, false);
                onChange && onChange(event);
            } }, restProps)));
    }));
};
exports.Radio.Button = antd_1.Radio.Button;
//# sourceMappingURL=index.js.map